<ng-container *ngIf="!item.hidden">

    <div *ngIf="item.title" class="group-title" [ngClass]="item.classes">
        <span class="hint-text">{{ item.title }}</span>
    </div>

    <div class="group-items">
        <ng-container *ngFor="let item of item.children">
            <fuse-nav-vertical-group *ngIf="isVisible(item, 'group')" [item]="item"></fuse-nav-vertical-group>
            <fuse-nav-vertical-collapsable *ngIf="isVisible(item, 'collapsable')"
                                           [item]="item"></fuse-nav-vertical-collapsable>
            <fuse-nav-vertical-item *ngIf="isVisible(item, 'item')" [item]="item"></fuse-nav-vertical-item>
        </ng-container>
    </div>

</ng-container>